import Request from "../Request";

/**
 * 近つ飛鳥用コード
 * TODO: 汎用的に使える部分はモジュール化したい
 * 
 * @type {IHChikatsuAsuka}
 */
module.exports = class IHChikatsuAsuka extends IH{
  
  constructor(options) {
    super(options);
    this.options = options;
    this.repositoryOptions = {
      type: 'facet',
      placeTypeFacetName: this.translationsExtend.facet.type.name,
      searchApi: 'search',
      multiSortValues: true,
      enableDividePlaceTypeBySpace: false,
      mappingItems: {
        lat: this.translationsExtend.attributes.lat,
        lng: this.translationsExtend.attributes.lng,
        image: this.translationsExtend.attributes.imageFile,
        image_label: this.translationsExtend.attributes.imageLabel,
        name: this.translationsExtend.attributes.name,
        address: this.translationsExtend.attributes.address,
        description: this.translationsExtend.attributes.description,
        info: 'info'
      },
      sortTarget: {
        kana: this.translationsExtend.attributes.kana,
        era: this.translationsExtend.facet.era.name
      },
      sortValue: {
        eras: {
          [this.translationsExtend.facet.era.value.jyomon]: 1,
          [this.translationsExtend.facet.era.value.pre_to_med]: 2,
          [this.translationsExtend.facet.era.value.yayoi]: 3,
          [this.translationsExtend.facet.era.value.prehistoric]: 4,
          [this.translationsExtend.facet.era.value.kofun]: 5,
          [this.translationsExtend.facet.era.value.asuka]: 6,
          [this.translationsExtend.facet.era.value.ancient]: 7,
          [this.translationsExtend.facet.era.value.nara]: 8,
          [this.translationsExtend.facet.era.value.heian]: 9,
          [this.translationsExtend.facet.era.value.kamakura]: 10,
          [this.translationsExtend.facet.era.value.early_med]: 11,
          [this.translationsExtend.facet.era.value.nanbokucho]: 12,
          [this.translationsExtend.facet.era.value.muromachi]: 13,
          [this.translationsExtend.facet.era.value.aduchimomoyama]: 14,
          [this.translationsExtend.facet.era.value.edo]: 15,
          [this.translationsExtend.facet.era.value.meiji]: 16,
          [this.translationsExtend.facet.era.value.taisho]: 17,
          [this.translationsExtend.facet.era.value.showa]: 18,
          [this.translationsExtend.facet.era.value.unknown]: 19
        }
      },
      firstSelection: this.translationsExtend.facet.type.value.iseki
    };
    if (this.locale === 'ja') {
      this.defaultSortKey = 'kana';
      this.defaultSortOrder = 1;  
    } else {
      this.defaultSortKey = 'era';
      this.defaultSortOrder = 1;
    }
    this.sortKey_1 = 'kana';
    this.sortOrder_1 = 1;
    this.sortKey_2 = 'era';
    this.sortOrder_2 = 1;
    this.detailMenus = [
      this.translationsExtend.attributes.kana,
      this.translationsExtend.facet.era.name,
      this.translationsExtend.attributes.assets
    ];
    this.searchTargetTypes = [];
    this.show_direction_on_marker_click = false;
    this.labelingZoomLevel = 15;
  
    /**
     * GoogleMap マップタイプ・マップコントロール設定
     */
    if (this.mapOptions.type === 'googlemap') {
      const gmap_options = {
        mapTypeId: google.maps.MapTypeId.TERRAIN,
        styles: [
          {
            "featureType": "poi.business",
            "elementType": "all",
            "stylers": [
              { "visibility": "off" }
            ]
          }
        ],
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM,
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          mapTypeIds: ['terrain', 'satellite']
        },
        streetViewControlOptions: {position: google.maps.ControlPosition.RIGHT_TOP},
        zoomControlOptions: {position: google.maps.ControlPosition.TOP_LEFT}
      };
      $.extend(true, this.mapOptions.gmap_options, gmap_options);
    }
  }
  
  reset() {
    super.reset();
    this.init();
  }
  
  init() {
    let that = this;
    
    $(that).on('ready', () => {
      this.rewriteEra(true);
      
      $(this).on('ihAfterTransformPlacesResponse', (event, request, assets) => {
        this.setMarkerIcon(assets);
      });
      // 詳細パネルとマーカーポップアップの内容の書き換え
      $(that).on('ihFillMarkerPopup', function(event, place, popup) {
        // 詳細パネル: アプリ固有の項目を作成する
        that.createDetailMenus(place, popup);
        // 詳細パネル: 画像ポップアップを作成する
        that.createImagePopup(place, popup);
      });
      
      // 同階層の複数ファセット値に属するデータがあるファセットにて、当該ファセット値選択による同階層の他のファセット値のデータ件数絞り込みを行わず、
      // 他のファセットのファセット値選択状態によるデータ件数絞り込みのみ反映する(=単一ファセット値に属するデータのみのファセットと同じ挙動とする)
      $(this.controller).on('ihAfterUpdateFacetValue', () => {
        let request = new Request({types: []});
        let targetId = null;
        let facetId = null;
        this.searchTargetTypes.forEach( (value, id) => {
          if (value) {
            const facet = this.repository.getFacetByItemId(id);
            if (facet.name === this.translationsExtend.facet.era.name) {
              targetId = id;
              facetId = facet.id;
            } else {
              request.opt.types.push(id);
            }
          }
        });
        if (targetId) {
          this.repository.getFacetCount(this.repository.buildFacetQuery(request)).then(counts => {
            _.forEach(counts, obj => {
              if (obj.id !== targetId && obj.facet_id == facetId && obj.count) {
                $('.js-facet-count[data-placetype="' + obj.id + '"]').text(obj.count);
              }
            });
          });
        }
      });
  
      // ズームレベルによって、遺跡マーカのラベルの表示・非表示を切替える
      let markerLabel;
      google.maps.event.addListener(that.map.getMap(), 'zoom_changed', function(){
        if (that.map.getMap().getZoom() < that.labelingZoomLevel) {
          $.each(that.map.getDisplayMarkers(), function() {
            this.setLabel(null);
          });
        } else if (that.map.getMap().getZoom() >= that.labelingZoomLevel){
          $.each(that.map.getDisplayMarkers(), function() {
            markerLabel = {
              text: this.name,
              color: "#493E26",
              fontSize: "14px",
              fontWeight: '400',
              fontFamily: 'ヒラギノ丸ゴ Pro W4,ヒラギノ丸ゴ Pro,Hiragino Maru Gothic Pro,ヒラギノ角ゴ Pro W3,' +
              'Hiragino Kaku Gothic Pro,HG丸ｺﾞｼｯｸM-PRO,HGMaruGothicMPRO',
            };
            this.setLabel(markerLabel);
          });
        }
      });
    });
  }
  
  /**
   *
   * @override
   * @protected
   */
  beforeStart() {
    return this.initFacets();
  }
  
  /**
   * ファセット一覧を取得して施設タイプを設定する
   *
   * @returns {*}
   */
  initFacets() {
    return this.repository.loadFacets().then(() => {
      this.setOptionsForPlaceTypes(this.repository.getPlaceTypes());
    });
  
  }
  
  /**
   * 詳細パネル: アプリ固有の項目を作成する
   *
   * @param place
   * @param popup
   */
  createDetailMenus(place, popup){
    for (let i = 0, len = this.detailMenus.length; i < len; i++ ) {
      let attr = this.detailMenus[i];
      let text = '';
      // 施設オブジェクトに項目名と同じプロパティあれば、プロパティ値を項目の内容として表示
      popup.find('.iw-facet-' + (i+1)).closest('.iw-item').hide();
      if (attr in place.attributes) {
        text = place.attributes[attr];
        if (text !== '') {
          // 繁体字の場合、時代区分のデリミタを「、」に変更
          if ((this.locale === 'zh-CN' || this.locale === 'zh-TW') && attr === this.translationsExtend.facet.era.name) {
            text = text.replace(/, /g, '、')
          }
          popup.find('.iw-facet-' + (i+1)).closest('.iw-item').find('.iw-label').text(attr);
          popup.find('.iw-facet-' + (i+1)).html(text);
          popup.find('.iw-facet-' + (i+1)).closest('.iw-item').show();
        }
      }
      // 日本語以外はよみがなを非表示
      if (this.locale !== 'ja' && attr === this.translationsExtend.attributes.kana) {
        popup.find('.iw-facet-' + (i+1)).closest('.iw-item').hide();
      }
    }
  }
  
  /**
   * 詳細パネル: 画像スライダー付きポップアップウィンドウを作成する
   *
   * @param place
   * @param popup
   */
  createImagePopup(place, popup){
    let credit = [];
    if ( place.image && popup.find('.iw-image-popup').length ){
  
      let imagePaths = place.image.split('|');                   // 画像パス ( 複数指定の場合、区切り文字は '|' )
      let imageTitles = place.attributes[this.translationsExtend.attributes.imageName].split('|');  // 画像名称 ( 複数指定の場合、区切り文字は '|' )
      let numOfImages = imagePaths.length;                       // 画像枚数
      credit = place.image_label.split('|');
    
      // 画像パスを整形
      for(let i = 0; i < numOfImages; i++) {
      
        // 改行や空白を削除
        imagePaths[i] = imagePaths[i].replace(/[\n\r\s]/g, '');
      
        // 画像パスがURLでなければ、ローカルパスを追加
        if (!imagePaths[i].match(/^http/)) {
          imagePaths[i] = this.place_image_path + imagePaths[i];
        }
      
      }
  
      // 画像枚数が2枚以上なら、ポップアップボタンの下に枚数表示
      const $imageCount = $('#iw-image-count');
      if(numOfImages > 1){
        if (this.locale === 'en') {
          $imageCount.text(`${numOfImages} ${this.translationsCommon.imageSlider.number}`);
          if (place.attributes['よみがな'] === 'しょうとくたいしぼこふん（えいふくじこふん）') {
            $imageCount.text(`${numOfImages} images`);
          }
        } else {
          $imageCount.text(`${numOfImages}${this.translationsCommon.imageSlider.number}`);
        }
      } else {
        $imageCount.text('');
      }
    
      popup.find('.iw-image-popup').show();
      let imagePopupContainer = popup.find('.iw-image-popup .iw-label');
      let imagePopup = $('#image-popup');
      
      // 画像ポップアップウィンドウとスライダの作成
      if ( imagePopup.length === 0 ){
      
        imagePopup = $('<div id="image-popup" data-role="popup" data-overlay-theme="a" data-theme="d" data-corners="false"></div>').appendTo( imagePopupContainer );
        //var imagePopupClose = $('<a href="#" data-rel="back" data-role="button" data-theme="a" class="ui-btn-right ui-btn ui-shadow ui-btn-corner-all ui-btn-icon-notext ui-btn-up-a"><span class="ui-btn-inner"><span class="ui-btn-text">Close</span><span class="ui-icon ui-icon-delete ui-icon-shadow">&nbsp;</span></span></a>').appendTo( imagePopup);
        //var img = $('<img>').appendTo( imagePopup );
      
        imagePopup.popup();
  
        // ポップアップを閉じるボタンを追加
        let closer = $('<button id="image-popup-closer" data-theme="f" class="ui-btn ui-corner-all ui-shadow ui-btn-inline ui-btn-up-f">' + this.translationsCommon.template.common.close + '</button>');
        closer.appendTo(imagePopup);
        closer.on('click', function () {
          imagePopup.popup('close');
        });
  
        // ポップアップを閉じるボタンのデザイン
        // ここで設定しないとデザインが反映されない
        closer.css({
          'padding': '5px 12px',
          'font-size': '1em'
        });
      
      }
  
      $('#image-slider').remove();
      $('.bx-wrapper').remove();
  
      // スライダー用のdiv要素を作成し、ポップアップウィンドウに追加
      let imageSlider = $('<div id="image-slider"></div>');
      imageSlider.appendTo(imagePopup);
      
      // img要素のtitle属性（スライダのキャプションに利用される）
      let title = '';
      
      // img要素を作成し、スライダー用divに追加
      for(let i = 0; i < numOfImages; i++) {
    
        // title属性に画像名称を設定
        if(imageTitles[i]) {
          // 「（名称なし）」なら替わりに遺跡名を表示
          if( imageTitles[i] === this.translationsExtend.template.imageSlider.noname) {
            title = '（' + place.name + '）';
          } else {
            title = imageTitles[i];
          }
          // 画像名称が空欄なら替わりに遺跡名を表示
        } else {
          title = '（' + place.name + '）';
        }
        
        // 画像は1枚目のみ読み込み、他はスライド直前に読み込み（遅延ロード）
        // 遅延ロードさせないと、ポップアップウィンドウ表示時に画像が一瞬縦に並んでしまう
        if (i === 0) {
          $('<div class="sliding-images"><img src="' + imagePaths[i] + '" title="' + title + '" id="sliding-image-' + i + '"></div>').appendTo(imageSlider);
        } else {
          $('<div class="sliding-images"><img title="' + title + '" id="sliding-image-' + i + '"></div>').appendTo(imageSlider);
        }
    
      }
  
      // ポップアップウィンドウの表示完了後にスライダを作成
      // これまでスライド作成できない不具合があったのは、恐らくポップアップ表示完了前にスライダが生成されいたため
      imagePopup.on( "popupafteropen", ( event, ui )=> {
        imageSlider.bxSlider({
          minSlides: 1,
          maxSlides: 1,
          slideMargin: 5,
          infiniteLoop: false,
          hideControlOnEnd: true,
          captions: true,
          // 画像遅延ロード
          onSlideBefore: function($slideElement, oldIndex, newIndex){
            $('#sliding-image-' + newIndex).attr('src', imagePaths[newIndex]);
            $('.mf-carousel-credit').remove();
            if (credit[newIndex].indexOf('none') === -1) {
              const _credit = credit[newIndex].replace('<br>', ' ');
              $('.bx-caption span').append('<span class="mf-carousel-credit">' + _credit + '</span>');
            }
          },
          onSliderLoad: function (currentIndex) {
            $('.mf-carousel-credit').remove();
            if (credit[0].indexOf('none') === -1) {
              const _credit = credit[0].replace('<br>', ' ');
              $('.bx-caption span').append('<span class="mf-carousel-credit">' + _credit + '</span>');
            }
          }
        });
      });
      
    }else{
      popup.find('.iw-image-popup').hide();
    }
  
    if (place.image_label && popup.find('.iw-image-label').length && credit[0].indexOf('none') === -1){
      popup.find('.iw-image-label-item').show();
      popup.find('.iw-image-label').html(credit[0]);
    }else{
      popup.find('.iw-image-label-item').hide();
    }
    
  }
  
  /**
   * マーカのアイコン画像を設定する
   *
   * @param assets
   */
  setMarkerIcon (assets) {
    _.forEach(assets, (asset, key) => {
      if ( asset.name === this.translationsExtend.assets.kusu || asset.name === this.translationsExtend.assets.tsubaki ) {
        assets[key].icon_pin = this.icon_file_path + 'tree_pin.png';
        assets[key].icon_min = this.icon_file_path + 'tree_min.png';
      } else {
        assets[key].icon_pin = this.icon_file_path + 'vase_pin.png';
        assets[key].icon_min = this.icon_file_path + 'vase_min.png';
      }
    });
  }
  
  /**
   * 時代区分ファセット値を書き換え
   *
   */
  rewriteEra () {
    $('.js-tooltip').each((i, elem) => {
      const $facetValue = $(elem).find('.ui-btn-text').find('span:not([class])');
      const era = $facetValue.text();
      let value2Key = null;
      _.forEach(this.translationsExtend.facet.era.value, (value, key) => {
        if (era === value) {
          value2Key = key;
        }
      });
      if (value2Key) {
        $facetValue.text(this.translationsExtend.facet.era.value2[value2Key]);
      }
    });
  }
  
  /**
   * @override
   * @returns {Array}
   */
  getSearchTargetTypes(){
    let types = [];
    for (let i in this.searchTargetTypes){
      if (this.searchTargetTypes[i]){
        types.push(i);
      }
    }
    return types;
  }
  
};



// WEBPACK FOOTER //
// ./map/js/ih/extend/IHChikatsuAsuka.js